"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TASK_PLAYLIST_SET_FETCH_MORE_RESULTS = exports.TASK_PLAYLIST_FETCH_MORE = exports.TASK_PLAYLIST_EXIT = exports.TASK_PLAYLIST_LOAD_CONFIG = exports.TASK_PLAYLIST_SET_CURRENT_TASK = void 0;
var TASK_PLAYLIST_SET_CURRENT_TASK = 'TASK_PLAYLIST_SET_CURRENT_TASK';
exports.TASK_PLAYLIST_SET_CURRENT_TASK = TASK_PLAYLIST_SET_CURRENT_TASK;
var TASK_PLAYLIST_LOAD_CONFIG = 'TASK_PLAYLIST_LOAD_CONFIG';
exports.TASK_PLAYLIST_LOAD_CONFIG = TASK_PLAYLIST_LOAD_CONFIG;
var TASK_PLAYLIST_EXIT = 'TASK_PLAYLIST_EXIT';
exports.TASK_PLAYLIST_EXIT = TASK_PLAYLIST_EXIT;
var TASK_PLAYLIST_FETCH_MORE = 'TASK_PLAYLIST_FETCH_MORE';
exports.TASK_PLAYLIST_FETCH_MORE = TASK_PLAYLIST_FETCH_MORE;
var TASK_PLAYLIST_SET_FETCH_MORE_RESULTS = 'TASK_PLAYLIST_SET_FETCH_MORE_RESULTS';
exports.TASK_PLAYLIST_SET_FETCH_MORE_RESULTS = TASK_PLAYLIST_SET_FETCH_MORE_RESULTS;